<!--
  Five columns including a photo do not fit a phone, so below 1024px the same
  rows are rendered as stacked cards instead of a table.
-->
@if (isCompact()) {
  <div class="room-cards">
    @for (element of dataSource.data; track element.roomDexId) {
      <bad-room-card
        [room]="element"
        (click)="clickRowHandler(element)"
        (keydown.enter)="clickRowHandler(element)"
        (keydown.space)="onCardSpace($event, element)"></bad-room-card>
    }
  </div>
} @else {
  <div class="rds-table-container">
    <table rds-table [dataSource]="dataSource" rdsSort>
      <ng-container rdsColumnDef="name">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>Room name</th>
        <td rds-cell *rdsCellDef="let element">
          <div class="name-cell">
            <p class="ui-heading-6-bold--s">
              {{ element.name }}
              <rds-icon
                [rdsTooltip]="
                  element.siteName +
                  ' ' +
                  element.buildingName +
                  ' ' +
                  element.floorName
                "
                icon="circle_info"
                namespace="outlined">
              </rds-icon>
            </p>
          </div>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="image">
        <th rds-header-cell *rdsHeaderCellDef></th>
        <td rds-cell *rdsCellDef="let element">
          <div class="image">
            @if (element.photo?.url) {
              <img [ngSrc]="element.photo.url" alt="room image" fill />
            }
          </div>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="description">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>Description</th>
        <td rds-cell *rdsCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>

      <ng-container rdsColumnDef="type">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>Room Type</th>
        <td rds-cell *rdsCellDef="let element">
          {{ element.type }}
        </td>
      </ng-container>

      <ng-container rdsColumnDef="capacity">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>Capacity</th>
        <td rds-cell *rdsCellDef="let element">
          {{ element.capacity }}
        </td>
      </ng-container>

      <ng-container rdsColumnDef="actions">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header></th>
        <td rds-cell *rdsCellDef="let element">
          <button rds-icon-button size="m">
            <rds-icon namespace="filled" icon="more_vertical"></rds-icon>
          </button>
        </td>
      </ng-container>

      <tr rds-header-row *rdsHeaderRowDef="displayedColumns"></tr>
      <tr
        rds-row
        *rdsRowDef="let row; columns: displayedColumns"
        (click)="clickRowHandler(row)"></tr>
    </table>
  </div>
}
